
 export enum ActivityVersion {
    V2="V2"
  }
  
 export const EHF_CATEGORY = "EHF"  